<template>
  <label :for="for_id" v-html="labelHtml"></label>
</template>
<script>
export default {
  name: "Label",
  props: {
    for_id: String,
    required: {
      type: Boolean,
      default: true,
    },
    label: String,
  },
  computed: {
    labelHtml() {
      if (this.required) {
        return this.label + '<span class="required-star"> *</span>';
      } else {
        return this.label;
      }
    },
  },
};
</script>
